import Handler from "../Handler";

class ExtraTimeHandler extends Handler {
    execute(message) {
        let receivedData = JSON.parse(message);
        this.service.processPlayerExtraTime(receivedData);
    }
}

export default ExtraTimeHandler;